import type { ElementKind } from './types'
import { KIOSK_ICONS } from './icons'

/** Glyphs for the add toolbar, 24-unit stroke paths. Lucide's (ISC) where the kiosk set has one. */
const OWN: Record<string, string> = {
  text: '<path d="M4 7V4h16v3" /><path d="M12 4v16" /><path d="M9 20h6" />',
  image: '<rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21" />',
  rule: '<path d="M3 12h18" />',
  panel: '<rect x="3" y="5" width="18" height="14" rx="4" />',
  media: '<rect x="2" y="4" width="20" height="16" rx="2" /><path d="m10 9 5 3-5 3z" />',
  ticker: '<path d="M3 7h18" /><path d="M3 17h18" /><path d="m10 10 4 2-4 2z" />',
  calls: '<path d="M8 6h13" /><path d="M8 12h13" /><path d="M8 18h13" /><path d="M3 6h.01" /><path d="M3 12h.01" /><path d="M3 18h.01" />',
  queues: '<path d="M4 20V10" /><path d="M10 20V4" /><path d="M16 20v-7" /><path d="M22 20H2" />',
  services: '<rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />',
  button: '<rect x="3" y="7" width="18" height="10" rx="3" />',
  page: '<path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2Z" /><path d="M14 2v6h6" />',
  back: '<path d="m15 18-6-6 6-6" />',
  booking: '<path d="M8 2v4" /><path d="M16 2v4" /><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M3 10h18" /><path d="m9 16 2 2 4-4" />',
  logo: '<path d="M9.94 15.5a2 2 0 0 0-1.44-1.44l-6.13-1.58a.5.5 0 0 1 0-.96L8.5 9.94A2 2 0 0 0 9.94 8.5l1.58-6.13a.5.5 0 0 1 .96 0l1.58 6.13a2 2 0 0 0 1.44 1.44l6.13 1.58a.5.5 0 0 1 0 .96l-6.13 1.58a2 2 0 0 0-1.44 1.44l-1.58 6.13a.5.5 0 0 1-.96 0z" />',
  kiosk: '<rect x="6" y="2" width="12" height="15" rx="2" /><path d="M10 21h4" /><path d="M12 17v4" /><path d="M10 6h4" />',
  display: '<rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8" /><path d="M12 17v4" />',
}

/** The glyph for a design kind, in the editor's header and its machine list. */
export type KindGlyph = 'kiosk' | 'display'

const FROM_KIOSK: Partial<Record<ElementKind, string>> = {
  waitingTotal: 'users',
  clock: 'clock',
  branchName: 'building-2',
  languages: 'globe',
  ticketNumber: 'ticket',
  ticketFacts: 'file-text',
  ticketPosition: 'users',
  ticketWait: 'clock',
  qr: 'qr-code',
  dateTime: 'calendar',
  validUntil: 'calendar',
  deskName: 'headset',
  serviceName: 'briefcase',
  deskStatus: 'info',
  deskNumber: 'headset',
  statusPill: 'info',
  clerkName: 'user',
}

/** The glyph for an element kind, or for 'page', 'back' and 'booking' buttons. */
export function addIcon(kind: ElementKind | 'page' | 'back' | 'booking' | KindGlyph): string {
  const k = FROM_KIOSK[kind as ElementKind]
  return (k && KIOSK_ICONS[k]) || OWN[kind] || OWN.button!
}
